import { render, staticRenderFns } from "./MobileBottomNav.vue?vue&type=template&id=d9bdb61e&scoped=true"
import script from "./MobileBottomNav.vue?vue&type=script&lang=js"
export * from "./MobileBottomNav.vue?vue&type=script&lang=js"
import style0 from "./MobileBottomNav.vue?vue&type=style&index=0&id=d9bdb61e&prod&scoped=true&lang=css"
import style1 from "./MobileBottomNav.vue?vue&type=style&index=1&id=d9bdb61e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bdb61e",
  null
  
)

export default component.exports